import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import DataParser from "../../../utlits/Dataparser";
import EvaluationService from "../../../Services/EvaluationService";
import UserServices from "../../../Services/UserService";
import WeightageServices from "../../../Services/weightagesService";
import SocketService from "../../../Services/SocketService";
import ReactSelect from "react-select";
import { message } from "antd";
import { useLocation } from "react-router-dom";

const Evaluation = () => {
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [weightages, setWeightages] = useState(null);
  const [manualAssigned, setManualAssigned] = useState("");
  const [manualCompleted, setManualCompleted] = useState("");
  const [remarks, setRemarks] = useState(""); // Remarks state
  const [attributeScores, setAttributeScores] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [dates, setDates] = useState("");
  const [allEvaluations, setAllEvaluations] = useState([]);

  const companyId = DataParser.CompanyId();
  const loggedUser = JSON.parse(secureLocalStorage.getItem("adminInfo"));
  const loggedUserId = loggedUser?.user?.userdata?.id;
  const loggedUserRole = loggedUser?.user?.userdata?.role_title?.toLowerCase();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1.5px solid #1D1D1D" : "1.5px solid #d0d0d0",
      borderRadius: "8px",
      minHeight: "44px",
      height: "44px",
      boxShadow: "none",
      fontSize: "14px",
      transition: "all 0.2s ease",
      backgroundColor: "#fff",
      "&:hover": {
        border: state.isFocused ? "1.5px solid #1D1D1D" : "1.5px solid #d0d0d0",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 14px",
      height: "44px",
      display: "flex",
      alignItems: "center",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
      caretColor: "black",
      color: "black",
      boxShadow: "none !important",
      outline: "none !important",
      border: "none !important",
      background: "transparent",
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: "0px",
      color: "#1D1D1D",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "44px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#999",
      padding: "0 8px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(13, 223, 171, 0.15)"
        : state.isFocused
          ? "#f5f5f5"
          : "#fff",
      color: "#1D1D1D",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      opacity: state.isDisabled ? 0.6 : 1,
      fontWeight: state.isSelected ? "600" : "400",
      "&:active": {
        backgroundColor: state.isDisabled ? "#fff" : "rgba(13, 223, 171, 0.15)",
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#fff",
      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      zIndex: 9999,
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#fff",
      maxHeight: "220px",
      overflowY: "auto",
      padding: 0,
    }),
  };

  const evalCacheKey = `eval_cache_${companyId}_${loggedUserId}`;
  const EVAL_CACHE_TTL = 90_000;

  const readEvalCache = () => {
    try {
      const raw = sessionStorage.getItem(evalCacheKey);
      if (!raw) return null;
      const { ts, d } = JSON.parse(raw);
      if (Date.now() - ts > EVAL_CACHE_TTL) return null;
      return d;
    } catch { return null; }
  };

  const writeEvalCache = (d) => {
    try { sessionStorage.setItem(evalCacheKey, JSON.stringify({ ts: Date.now(), d })); } catch { }
  };

  const clearEvalCache = () => {
    try { sessionStorage.removeItem(evalCacheKey); } catch { }
  };

  const fetchAllEvaluations = () => {
    return EvaluationService.getallevaluation(companyId, loggedUserId, loggedUserRole)
      .then(res => {
        const list = res?.data.evaluations || [];
        setAllEvaluations(list);
        return list;
      })
      .catch(err => {
        console.error("Failed to load evaluations", err);
        setAllEvaluations([]);
        return [];
      });
  };

  // Fetch users
  const fetchUsers = (periodDates = null) => {
    const sDate = periodDates?.startDate || dates?.startDate;
    const eDate = periodDates?.endDate || dates?.endDate;

    return UserServices.getUsernames(companyId, sDate, eDate)
      .then(res => {
        const allUsers = res.data.user || [];
        const nonAdminUsers = allUsers.filter(u => u.role_title?.toLowerCase() !== "company admin");
        const filtered = nonAdminUsers.filter(u => Number(u.report_to) === loggedUserId);
        setUsers(filtered);
        return filtered;
      })
      .catch(err => { console.error("Failed to load users", err); return []; });
  };

  const fetchPeriodDates = () => {
    return EvaluationService.getPeriodDates(companyId, loggedUserId)
      .then(res => {
        setDates(res.data);
        return res.data;
      })
      .catch(err => { console.error("Failed to load dates", err); return null; });
  };

  // Fetch weightages
  const fetchWeightages = () => {
    return WeightageServices.getWeightages(companyId)
      .then(res => {
        const w = res.data.weightages?.[0];
        setWeightages(w);
        const attrs = w?.attribute?.map(attr => ({ title: attr.attributetitle, score: "" })) || [];
        setAttributeScores(attrs);
        return w;
      })
      .catch(err => { console.error("Failed to load weightages", err); return undefined; });
  };

  const doFetch = (showPageLoader) => {
    if (showPageLoader) setPageLoading(true);
    return Promise.all([
      fetchWeightages(),
      fetchPeriodDates().then(periodData => {
        if (periodData?.startDate && periodData?.endDate) {
          return fetchUsers(periodData).then(u => ({ periodData, users: u }));
        }
        return { periodData, users: [] };
      }),
      fetchAllEvaluations(),
    ]).then(([w, { periodData: pd, users: u }, evs]) => {
      writeEvalCache({ weightages: w, dates: pd, users: u, allEvaluations: evs });
    }).finally(() => { if (showPageLoader) setPageLoading(false); });
  };

  const loadAllData = (showPageLoader = false) => {
    const cached = readEvalCache();
    if (cached) {
      if (cached.weightages !== undefined) {
        setWeightages(cached.weightages);
        setAttributeScores(cached.weightages?.attribute?.map(a => ({ title: a.attributetitle, score: "" })) || []);
      }
      if (cached.dates !== undefined) setDates(cached.dates);
      if (cached.users !== undefined) setUsers(cached.users);
      if (cached.allEvaluations !== undefined) setAllEvaluations(cached.allEvaluations);
      doFetch(false);
      return;
    }
    doFetch(showPageLoader);
  };

  // Initial load with page spinner
  useEffect(() => {
    loadAllData(true);
  }, []);

  // Re-fetch fresh data every time user navigates to this page (fixes stale completion screen)
  useEffect(() => {
    loadAllData(false);
  }, [location.key]);

  // 🟢 Socket Integration
  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();

    const handleEvaluationUpdate = (data) => {
      console.log("🔔 Evaluation update received (Raw):", data);
      if (Number(data.company_id) === Number(companyId)) {
        console.log("✅ Evaluation update matched company:", data);
        fetchAllEvaluations();
        fetchPeriodDates();
      } else {
        console.log("❌ Evaluation update ignored (Company ID mismatch):", data.company_id, companyId);
      }
    };

    SocketService.on("evaluation_update", handleEvaluationUpdate);

    return () => {
      SocketService.off("evaluation_update", handleEvaluationUpdate);
    };
  }, []);

  const handleUserChange = (selectedOption) => {
    const userId = selectedOption ? selectedOption.value : "";
    setSelectedUser(userId);
    setUserData(null);
  };

  // Attribute score cannot exceed 10 (fixed immutably)

  // Attribute score cannot exceed 10 (fixed immutably)
  const handleAttributeScoreChange = (index, value) => {
    if (Number(value) < 0) return;
    const val = value === "" ? "" : Math.min(10, Number(value));
    setAttributeScores(prev => prev.map((attr, idx) =>
      idx === index ? { ...attr, score: val } : attr
    ));
  };

  // Calculate manager review score based on entered attribute scores
  const calculateManagerScore = () => {
    if (!weightages || !weightages.attribute) return 0;



    const managerWeightage = parseFloat(weightages.managerweightage || 0);
    const numAttributes = weightages.attribute.length;
    if (numAttributes === 0) return 0;

    const perAttrMax = managerWeightage / numAttributes;

    const total = attributeScores.reduce((sum, attr) => {
      const score = Number(attr.score) || 0;
      const percentage = score / 10;
      return sum + perAttrMax * percentage;
    }, 0);

    return Math.min(total, managerWeightage);
  };

  const handleCalculateAndSave = async () => {
    if (!selectedUser) {
      message.error("Please select a user first!");
      return;
    }

    if (weightages?.taskprocess?.toLowerCase() === "manual") {
      if (!manualAssigned.toString().trim()) {
        message.error("Assigned Task field cannot be empty!");
        return;
      }
      if (!manualCompleted.toString().trim()) {
        message.error("Completed Task field cannot be empty!");
        return;
      }
      if (Number(manualCompleted) > Number(manualAssigned)) {
        message.error("Completed tasks cannot be more than assigned tasks!");
        return;
      }
    }

    for (let i = 0; i < attributeScores.length; i++) {
      if (!attributeScores[i].score.toString().trim()) {
        message.error(`Score is required for attribute: ${attributeScores[i].title}`);
        return;
      }
    }

    setIsLoading(true);

    try {
      const managerScore = calculateManagerScore();

      // Single API call — backend calculates + saves in one pass (no duplicate heavy computation)
      const res = await EvaluationService.calculateAndSave({
        user_id: Number(selectedUser),
        company_id: Number(companyId),
        evaluationby: Number(loggedUserId),
        manualAssigned: Number(manualAssigned) || 0,
        manualCompleted: Number(manualCompleted) || 0,
        startDate: dates.startDate,
        endDate: dates.endDate,
        remarks: remarks || "",
        managerreviewscore: managerScore ? Number(managerScore).toFixed(2) : "0.00",
      });

      if (res.Good) {
        message.success("Evaluation saved successfully!");
        clearEvalCache();

        const freshPeriod = await fetchPeriodDates();
        await Promise.all([
          fetchAllEvaluations(),
          freshPeriod?.startDate ? fetchUsers(freshPeriod) : fetchUsers(),
        ]);

        setSelectedUser("");
        setUserData(null);
        setManualAssigned("");
        setManualCompleted("");
        setRemarks("");

        if (weightages?.attribute) {
          setAttributeScores(weightages.attribute.map(attr => ({
            title: attr.attributetitle,
            score: ""
          })));
        }
      } else {
        message.error("Failed to save evaluation.");
      }
    } catch (err) {
      console.error("Evaluation error:", err);
      message.error("An error occurred during evaluation.");
    } finally {
      setIsLoading(false);
    }
  };

  const noUsersAvailable = !pageLoading && users.length === 0;


  const formatDateOnly = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };



  // Computed same-render as the data — no extra render cycle, no flash
  const allDoneForPeriod = useMemo(() => {
    if (!dates?.startDate || !dates?.endDate || users.length === 0 || allEvaluations.length === 0) return false;
    const periodEndMoment = moment(dates.endDate).startOf("day");
    const pStart = moment(dates.startDate).format("YYYY-MM-DD");
    const pEnd = moment(dates.endDate).format("YYYY-MM-DD");
    const evaluatedSet = new Set(
      allEvaluations
        .filter(ev =>
          ev.company_id === Number(companyId) &&
          moment(ev.periodstart).format("YYYY-MM-DD") === pStart &&
          moment(ev.periodend).format("YYYY-MM-DD") === pEnd
        )
        .map(ev => Number(ev.userid))
    );
    return users.every(u => {
      const joinDate = moment(u.createdAt).startOf("day");
      return evaluatedSet.has(Number(u.id)) || u.status !== 1 ||
        (joinDate.isValid() && joinDate.isAfter(periodEndMoment)) || u.isOnLeaveFullPeriod;
    });
  }, [dates, users, allEvaluations, companyId]);

  const allEvaluatedForPeriod = allDoneForPeriod && !!dates?.isLatest;

  // Side effect: if all done but showing a non-latest period, advance to next
  useEffect(() => {
    if (allDoneForPeriod && !dates?.isLatest) {
      fetchPeriodDates().then(p => { if (p?.startDate) fetchUsers(p); });
    }
  }, [allDoneForPeriod, dates?.isLatest]);



  const processedUsers = useMemo(() => {
    if (!dates?.startDate || !dates?.endDate) {
      return users.map(u => ({ ...u, isEvaluated: false, isFutureJoiner: false, isInactive: u.status !== 1 }));
    }

    const pStart = moment(dates.startDate).format("YYYY-MM-DD");
    const pEnd = moment(dates.endDate).format("YYYY-MM-DD");
    const periodEndMoment = moment(dates.endDate).startOf("day");

    const evaluatedUserIds = new Set(
      (allEvaluations || [])
        .filter(ev =>
          ev.company_id === Number(companyId) &&
          moment(ev.periodstart).format("YYYY-MM-DD") === pStart &&
          moment(ev.periodend).format("YYYY-MM-DD") === pEnd
        )
        .map(ev => Number(ev.userid))
    );

    return users.map(u => {
      const joinDate = moment(u.createdAt).startOf("day");
      return {
        ...u,
        isEvaluated: evaluatedUserIds.has(Number(u.id)),
        isFutureJoiner: joinDate.isValid() && joinDate.isAfter(periodEndMoment),
        isInactive: u.status !== 1,
      };
    });
  }, [users, allEvaluations, dates]);
  const noReporteesAssigned = !pageLoading && users.length === 0;

  // Prepare Options for React Select - ONLY ACTIVE AND EVALUATABLE USERS
  const evolvabaleUsers = processedUsers.filter(u => !u.isInactive && !u.isFutureJoiner && !u.isOnLeaveFullPeriod && !u.isEvaluated);

  const userOptions = processedUsers
    .map((u) => {
      let label = u.full_name;
      let isDisabled = false;

      if (u.isInactive) {
        label += " (Inactive)";
        isDisabled = true;
      } else if (u.isFutureJoiner) {
        label += " (Not Joined)";
        isDisabled = true;
      } else if (u.isEvaluated) {
        label += " (Evaluated)";
        isDisabled = true;
      } else if (u.isOnLeaveFullPeriod) {
        label += " (On Leave)";
        isDisabled = true;
      }

      return {
        value: u.id,
        label: label,
        isDisabled: isDisabled,
      };
    });

  const selectedOption = userOptions.find((opt) => String(opt.value) === String(selectedUser)) || null;

  return (
    <>
      <style>{`
        .form-control:focus, 
        .form-select:focus,
        input:focus {
          border-color: #1D1D1D !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .float-input-wrap, .float-select-wrap {
          margin-bottom: 6px;
        }

        .float-input-wrap label, .float-select-wrap label {
          background-color: #fff !important;
        }
        
        .card {
          border: none !important;
          box-shadow: none !important;
          border-radius: 0 !important;
        }

        .icon-circle {
          background-color: #f4f4f4 !important;
        }
        
        .icon-circle i {
          color: #1D1D1D !important;
        }
      `}</style>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh", paddingBottom: "60px" }}>
          <div className="container-fluid px-0">

            {dates && dates.period && (
              <div className="row mb-1 g-0">
                <div className="col-12">
                  <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", background: "#f0f2f5", border: "1px solid #e1e5eb !important" }}>
                    <div className="card-body px-4 py-3 d-flex align-items-center">
                      <div className="me-3" style={{ width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "10px", backgroundColor: "#0DDFAB", flexShrink: 0 }}>
                        <i className="uil-calendar-alt" style={{ color: "#1D1D1D", fontSize: "18px" }}></i>
                      </div>
                      <div>
                        <h6 className="mb-1 fw-bold" style={{ fontSize: "18px", color: "#333" }}>
                          {dates.period} Evaluation Period
                        </h6>
                        <div className="d-flex align-items-center text-muted" style={{ fontSize: "14px" }}>
                          <i className="uil-clock-three me-1"></i>
                          {formatDateOnly(dates.startDate)} – {formatDateOnly(dates.endDate)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {pageLoading ? (
              <div className="row g-0">
                <style>{`
                  @keyframes evalShimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                  }
                  .eval-skel { border-radius: 12px; background: linear-gradient(90deg,#f0f0f0 25%,#e8e8e8 50%,#f0f0f0 75%); background-size: 800px 100%; animation: evalShimmer 1.4s infinite linear; }
                `}</style>
                <div className="col-12 mb-3"><div className="eval-skel" style={{ height: "76px" }}></div></div>
                <div className="col-12 mb-3"><div className="eval-skel" style={{ height: "80px" }}></div></div>
                <div className="col-12 mb-3"><div className="eval-skel" style={{ height: "120px" }}></div></div>
                <div className="col-12 mb-3"><div className="eval-skel" style={{ height: "80px" }}></div></div>
              </div>
            ) : !dates || !dates.period || !dates.startDate || !dates.endDate ? (
              <div className="row g-0">
                <div className="col-12">
                  <div
                    className="alert"
                    style={{
                      backgroundColor: "#fff3cd",
                      border: "1px solid #ffc107",
                      color: "#856404",
                      padding: "20px",
                      borderRadius: "8px",
                      textAlign: "center"
                    }}
                  >
                    <h5 style={{ marginBottom: "10px", fontWeight: 600 }}>
                      <i className="uil-exclamation-triangle me-2"></i>
                      No Performance Period Found
                    </h5>
                    <p style={{ marginBottom: 0, fontSize: "14px" }}>
                      Performance period is not added yet. Please add performance period from the settings or contact Company Admin.
                    </p>
                  </div>
                </div>
              </div>
            ) : allEvaluatedForPeriod ? (
              <div className="row mb-1 g-0">
                <div className="col-12">
                  <div
                    className="alert"
                    style={{
                      backgroundColor: "#f0fbfb",
                      border: "1px solid #cfeeee",
                      color: "#055",
                      padding: "40px 30px",
                      borderRadius: "16px",
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(13, 223, 171, 0.05)"
                    }}
                  >
                    <div className="mx-auto mb-4" style={{ width: "70px", height: "70px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", backgroundColor: "#0DDFAB" }}>
                      <i className="uil uil-check-circle" style={{ color: "#1D1D1D", fontSize: "36px" }}></i>
                    </div>
                    <h5 style={{ marginBottom: "12px", fontWeight: 700, color: "#0f223a", fontSize: "20px" }}>
                      All Evaluations Completed
                    </h5>
                    <p style={{ marginBottom: 0, fontSize: "16px", color: "#555", maxWidth: "550px", margin: "0 auto", lineHeight: "1.6" }}>
                      You have successfully completed evaluations for all of your reporting
                      users for the current evaluation period ({dates.period}).
                      <br />
                      <span style={{ fontSize: "14px", color: "#8c8c8c" }}>Next period evaluations will be available once it begins.</span>
                    </p>
                  </div>
                </div>
              </div>
            ) : noReporteesAssigned ? (
              <div className="row g-0">
                <div className="col-12">
                  <div
                    className="alert"
                    style={{
                      backgroundColor: "#f0fbfb",
                      border: "1px solid #cfeeee",
                      color: "#055",
                      padding: "40px 30px",
                      borderRadius: "16px",
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(13, 223, 171, 0.05)"
                    }}
                  >
                    <div className="mx-auto mb-4" style={{ width: "70px", height: "70px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", backgroundColor: "#0DDFAB" }}>
                      <i className="uil uil-users-alt" style={{ color: "#1D1D1D", fontSize: "36px" }}></i>
                    </div>
                    <h5 style={{ marginBottom: "12px", fontWeight: 700, color: "#0f223a", fontSize: "20px" }}>
                      No Reportee Found
                    </h5>
                    <p style={{ marginBottom: 0, fontSize: "16px", color: "#555", maxWidth: "450px", margin: "0 auto", lineHeight: "1.6" }}>
                      {loggedUserRole === "company admin"
                        ? "No reportees found for your account. Please assign users as your reportees to start evaluations."
                        : "Currently, no user is reporting to you. Evaluations can only be performed for users assigned as your reportees."}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* Select User Card */}
                <div className="row mb-1 g-0">
                  <div className="col-12">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
                      <div className="card-header bg-white border-0 py-2 px-4 d-flex align-items-center">
                        <div className="me-3" style={{ width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "10px", backgroundColor: "#0DDFAB", flexShrink: 0 }}>
                          <i className="uil-user" style={{ color: "#1D1D1D", fontSize: "18px" }}></i>
                        </div>
                        <h5 className="card-title mb-0 fw-bold" style={{ color: "#0f223a" }}>
                          Select User
                        </h5>
                      </div>
                      <div className="card-body px-4 pb-1 pt-2">
                        <div className="row g-0">
                          <div className="col-lg-6">
                            <div className={`float-select-wrap ${selectedUser ? "has-value" : ""}`}>
                              <ReactSelect
                                key={`eval-user-${selectedUser}`}
                                options={userOptions}
                                value={selectedOption}
                                onChange={handleUserChange}
                                styles={customStyles}
                                placeholder=""
                                isClearable={false}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#eee',
                                  },
                                })}
                              />
                              <label>Select User For Evaluation</label>
                            </div>
                            {users.length > 0 && processedUsers.every(u => u.isEvaluated) && (
                              <div className="alert alert-info mt-3 border-0" style={{ backgroundColor: "rgba(13, 223, 171, 0.05)", color: "#0DDFAB", borderRadius: "10px" }}>
                                <i className="uil-info-circle me-2"></i>
                                All reporting users have been evaluated for this period.
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Manual Inputs Card */}
                {weightages?.taskprocess?.toLowerCase() === "manual" && (
                  <div className="row mb-1 g-0">
                    <div className="col-12">
                      <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
                        <div className="card-header bg-white border-0 py-2 px-4 d-flex align-items-center">
                          <div className="me-3" style={{ width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "10px", backgroundColor: "#0DDFAB", flexShrink: 0 }}>
                            <i className="uil-edit" style={{ color: "#1D1D1D", fontSize: "18px" }}></i>
                          </div>
                          <h5 className="card-title mb-0 fw-bold" style={{ color: "#0f223a" }}>
                            Manual Task Calculation
                          </h5>
                        </div>
                        <div className="card-body px-4 pb-1 pt-2">
                          <div className="row g-3">
                            <div className="col-lg-4">
                              <div className="float-input-wrap">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={manualAssigned}
                                  onChange={e => {
                                    if (Number(e.target.value) >= 0) setManualAssigned(e.target.value)
                                  }}
                                  placeholder=" "
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <label>Total Assigned Tasks</label>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="float-input-wrap">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={manualCompleted}
                                  onChange={e => {
                                    if (Number(e.target.value) >= 0) setManualCompleted(e.target.value)
                                  }}
                                  placeholder=" "
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <label>Total Completed Tasks</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Manager Attributes Score Card */}
                <div className="row mb-1 g-0">
                  <div className="col-12">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
                      <div className="card-header bg-white border-0 py-2 px-4 d-flex align-items-center">
                        <div className="me-3" style={{ width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "10px", backgroundColor: "#0DDFAB", flexShrink: 0 }}>
                          <i className="uil-star" style={{ color: "#1D1D1D", fontSize: "18px" }}></i>
                        </div>
                        <h5 className="card-title mb-0 fw-bold" style={{ color: "#0f223a" }}>
                          Manager Attributes Score
                        </h5>
                      </div>
                      <div className="card-body px-4 pb-1 pt-2">
                        <div className="row g-3">
                          {attributeScores.map((attr, idx) => (
                            <div key={idx} className="col-lg-4">
                              <div className="float-input-wrap">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={attr.score}
                                  onChange={e => handleAttributeScoreChange(idx, e.target.value)}
                                  placeholder=" "
                                  max="10"
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <label>{attr.title}</label>
                              </div>
                            </div>
                          ))}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                {/* Remarks Section - Always Visible */}
                <div className="row mb-1 g-0">
                  <div className="col-12">
                    <div className="card border-0 shadow-sm" style={{ borderRadius: "12px" }}>
                      <div className="card-header bg-white border-0 py-2 px-4 d-flex align-items-center">
                        <div className="me-3" style={{ width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "10px", backgroundColor: "#0DDFAB", flexShrink: 0 }}>
                          <i className="uil-comment-alt-notes" style={{ color: "#1D1D1D", fontSize: "18px" }}></i>
                        </div>
                        <h5 className="card-title mb-0 fw-bold" style={{ color: "#0f223a" }}>
                          Remarks
                        </h5>
                      </div>
                      <div className="card-body px-4 pb-1 pt-2">
                        <div className="row g-0">
                          <div className="col-12">
                            <div className={`float-input-wrap ${remarks ? "has-value" : ""}`}>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder=" "
                                style={{ borderRadius: "10px", border: "1.5px solid #d0d0d0", fontSize: "14px", padding: "15px" }}
                              ></textarea>
                              <label>Additional Remarks (Optional)</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Single Calculate & Save Button */}
                <div className="row mt-3 g-0">
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      className="btn btn-primary px-4 fw-bold glow"
                      onClick={handleCalculateAndSave}
                      disabled={isLoading}
                      style={{ borderRadius: "50px", backgroundColor: "#0DDFAB", borderColor: "#0DDFAB", color: "#fff", height: "42px", whiteSpace: "nowrap", pointerEvents: isLoading ? "none" : "auto" }}
                      onMouseOver={e => { e.currentTarget.style.backgroundColor = "#0DDFAB"; e.currentTarget.style.color = "#fff"; }}
                      onMouseOut={e => { e.currentTarget.style.backgroundColor = "#0DDFAB"; e.currentTarget.style.color = "#fff"; }}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style={{ color: "#fff", borderColor: "#fff", borderRightColor: "transparent" }}></span>
                          Saving Evaluation...
                        </>
                      ) : (
                        <>
                          <i className="uil-calculator-alt me-2"></i>Calculate Evaluation
                        </>
                      )}
                    </button>
                  </div>
                </div>


              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};


export default Evaluation;
